import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, Input, Output, OnInit} from '@angular/core';
import {faBookmark as bookmarkIcon} from '@fortawesome/pro-regular-svg-icons';
import { Router } from '@angular/router';
import { select, Store, } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import {
  doesUserHavePermission,
  getSidebarBookmark,
  getSidebarSavedSearch
} from 'user/reducers/user.reducer';
import {showSidebarBookmark, showSidebarSavedSearch} from 'user/actions/user-profile.actions';
import {isAuthorizedInKeycloak} from '../../../../keycloak/reducers/keycloak.reducer';
import {UserPermission} from 'user/models/user';

@Component({
  selector: 'app-ap-bookmark',
  templateUrl: './ap-bookmark.component.html',
  styleUrls: ['./ap-bookmark.component.scss']
})
export class ApBookmarkComponent implements OnInit, OnDestroy {
  @Input() public isDisplayed: boolean;
  @Output() public isDisplayedChange = new EventEmitter<boolean>();
  public readonly bookmarkIcon = bookmarkIcon;
  private readonly subscriptions: Subscription = new Subscription();
  public sidebarBookmark: boolean = false;
  public sidebarSavedSearch: boolean = false;
  public showSidebarSavedSearch: boolean = false;

  constructor(
    private router: Router,
    public readonly store: Store,
    private chRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    // Subscribe to sidebar bookmark and saved search state
    this.subscriptions.add(this.store.select(getSidebarBookmark).subscribe((sidebarBookmark) => {
      // Update local state
      this.sidebarBookmark = sidebarBookmark;
      // If bookmark sidebar is opened, close saved search sidebar
      if (this.sidebarBookmark && this.sidebarSavedSearch) {
        this.store.dispatch(showSidebarSavedSearch({sidebarSavedSearch: !this.sidebarSavedSearch}));
      }
      this.chRef.detectChanges();
    }));
    // Subscribe to sidebar saved search state
    this.subscriptions.add(this.store.select(getSidebarSavedSearch).subscribe((sidebarSavedSearch) => {
      // Update local state
      this.sidebarSavedSearch = sidebarSavedSearch;
      // If saved search sidebar is opened, close bookmark sidebar
      if (this.sidebarBookmark && this.sidebarSavedSearch) {
        this.store.dispatch(showSidebarBookmark({sidebarBookmark: !this.sidebarBookmark}));
      }
      this.chRef.detectChanges();
    }));

    this.subscriptions.add(
      combineLatest([
        this.store.pipe(select(isAuthorizedInKeycloak)),
        this.store.pipe(select(doesUserHavePermission(UserPermission.SHOWCASES_VIEW))),
        this.router.events,
      ])
        .subscribe(([isPatronAuthorized, hasViewShowcasesPermission]) => {
          this.showSidebarSavedSearch = hasViewShowcasesPermission;
          this.isDisplayed = isPatronAuthorized;
          if (this.router.url === '/portal') {
            this.isDisplayed = false;
          }
          this.isDisplayedChange.emit(this.isDisplayed);
          this.chRef.markForCheck();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public showBookmark() {
    // Toggle bookmark sidebar
    this.store.dispatch(showSidebarBookmark({sidebarBookmark: !this.sidebarBookmark}));
  }

  public showSavedSearch() {
    // Toggle saved search sidebar
    this.store.dispatch(showSidebarSavedSearch({sidebarSavedSearch: !this.sidebarSavedSearch}));
  }
}
